import { useCallback } from 'react';
import { StyledButton } from '../ImageViewer.style';
import { TemperatureOutlined } from '../Icons/TemperatureIcon';

type TemperatureProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
};

export const Temperature: React.FunctionComponent<TemperatureProps> = ({
  onChange,
  value = false,
  disabled = false,
}) => {
  const handleClick = useCallback(() => {
    onChange({ temperature: !value });
  }, [value, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-temperature"
      title="Measure Temperature"
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
      icon={<TemperatureOutlined />}
    />
  );
};
